import { render, staticRenderFns } from "./collapsible.vue?vue&type=template&id=0d9c050e&scoped=true"
import script from "./collapsible.vue?vue&type=script&lang=js"
export * from "./collapsible.vue?vue&type=script&lang=js"
import style0 from "./collapsible.vue?vue&type=style&index=0&id=0d9c050e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c050e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9c050e')) {
      api.createRecord('0d9c050e', component.options)
    } else {
      api.reload('0d9c050e', component.options)
    }
    module.hot.accept("./collapsible.vue?vue&type=template&id=0d9c050e&scoped=true", function () {
      api.rerender('0d9c050e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/collapsible.vue"
export default component.exports